export default {
  title: '黑名單管理',
  tip: '加入黑名單的會員將無法參與任何會員活動，可在此處管理黑名單成員。',
  columns: {
    id: 'ID',
    nickname: '會員暱稱',
    level: '會員等級',
    country: '所在國家',
    email: '郵箱',
    phone: '手機號',
    wechat: '微信號',
    registerTime: '註冊時間',
  },
  actions: {
    remove: '撤銷黑名單',
  },
  removeConfirm: {
    title: '確定將該用戶撤銷黑名單嗎？',
    tip: '撤銷黑名單後，該用戶將正常參與所有活動。',
  },
};
